import {Component, Type, Texture, WonderlandEngine, property, Material, MeshComponent} from '@wonderlandengine/api';

class DynamicTextureCache {
    engine: WonderlandEngine;
    textures: {};
    constructor(engine: WonderlandEngine) {
        this.textures = {};
        this.engine = engine;
    }
    loadTextures(url, columns, rows) {
        if (!this.textures.hasOwnProperty(url)) {
            this.textures[url] = new Promise((resolve, reject) => {
                let image = new Image();
                let textures = [];
                image.src = url;
                image.onload = () => {
                    let canvas = document.createElement('canvas');
                    let context = canvas.getContext('2d');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    context.drawImage(image, 0, 0);
                    let spriteWidth = image.width / columns;
                    let spriteHeight = image.height / rows;

                    for (let y = 0; y < rows; y++) {
                        for (let x = 0; x < columns; x++) {
                            let pc = this.copyPartOfCanvas(
                                canvas,
                                x * spriteWidth,
                                y * spriteHeight,
                                spriteWidth,
                                spriteHeight
                            );
                            let texturePc = this.engine.textures.create(pc);
                            textures.push(texturePc);
                        }
                    }
                    resolve(textures);
                };
            });
        }
        return this.textures[url];
    }

    copyPartOfCanvas(canvas, x, y, width, height) {
        let copy = document.createElement('canvas');
        copy.width = width;
        copy.height = height;
        let ctx2 = copy.getContext('2d');
        ctx2.drawImage(canvas, x, y, width, height, 0, 0, width, height);
        return copy;
    }
}
/**
 * @type {DynamicTextureCache}
 */
let textureCache;

export class Flipbook extends Component {
    static TypeName = 'flipbook';

    @property.material()
    base: Material;

    @property.string('')
    url = '';

    @property.string('')
    urlEmissive = '';

    @property.int(4)
    columns = 4;

    @property.int(4)
    rows = 4;

    @property.float(8.0)
    speed = 8.0;
    textures: any[];
    loaded: boolean;
    index: number;
    mat: MeshComponent;
    t: number;
    previousIndex: any;

    start() {
        if (!textureCache) {
            textureCache = new DynamicTextureCache(this.engine);
        }
        let texturesPromises = [];

        texturesPromises.push(textureCache.loadTextures(this.url, this.columns, this.rows));
        if (this.urlEmissive) {
            texturesPromises.push(textureCache.loadTextures(this.urlEmissive, this.columns, this.rows));
        }

        Promise.all(texturesPromises).then((tex) => {
            this.textures = [];

            if (this.urlEmissive) {
                for (let i = 0; i < tex[0].length; i++) {
                    this.textures.push(this.createMaterial(this.base, tex[0][i], tex[1][i]));
                }
            } else {
                for (let i = 0; i < tex[0].length; i++) {
                    this.textures.push(this.createMaterial(this.base, tex[0][i]));
                }
            }

            this.loaded = true;
            this.index = Math.floor(Math.random() * this.textures.length);
        });

        this.mat = this.object.getComponent(MeshComponent);
        this.t = Math.random() * this.speed;
    }

    createMaterial(base, texture, emissiveTexture = null) {
        let mat = base.clone();
        if (mat.shader == 'Flat Opaque Textured') {
            mat.flatTexture = texture;
        } else if (mat.shader == 'FlatSorskoot') {
            mat.flatTexture = texture;
        } else if (mat.shader == 'FlatSorskoot Emissive') {
            mat.flatTexture = texture;
            if (emissiveTexture) {
                mat.emissiveTexture = emissiveTexture;
            }
        } else {
            console.error('Shader', mat.shader, 'not supported by flipbook');
        }
        return mat;
    }

    update(dt) {
        if (!this.loaded) return;
        this.t += dt * this.speed;
        this.index = ~~this.t % this.textures.length;
        if (this.textures && this.textures.length && this.previousIndex != this.index) {
            this.previousIndex = this.index;
            this.mat.material = this.textures[this.index];
        }
    }
}
